<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :incluirInactivos="incluirInactivos"
          :labelCols="3"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Organismos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :items="impuestosOrganismos" 
              :fields="itemFields"
              :busy="tableBusy"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              

            <template v-slot:cell(inactivo)="data">
              {{ data.item.inactivo ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Organismo</b-dropdown-item>

                <b-dropdown-item @click.stop="consultarImpuestos(data.item)">
                  <i class="fa fa-user"></i>Consultar Impuestos</b-dropdown-item>
              </b-dropdown>

            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Filtro from '../shared/listFiltroNombre.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'impuestosOrganismos/getField',
  mutationType: 'impuestosOrganismos/updateField',
});

export default {
  name: 'ImpuestosOrganismos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      itemFields: [
        {
          key: 'nombre',
          sortable: true
        },
        { key: 'inactivo' },
        {
          key: 'opciones',
          label: '',
          class: "text-center"
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'impuestosOrganismos',
      'nombre',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('impuestosOrganismos/getImpuestosOrganismos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'ImpuestoOrganismoDatos', 
                          params: { id: item.id }})
    },
    consultarImpuestos (item) {
      this.$router.push({ name: 'Impuestos', 
                          params: { impuestoOrganismoId: item.id }})
    },
    editar (item) {
      this.$router.push({ name: 'ImpuestoOrganismoABM', 
                          params: { id: item.id }})
    },
    agregar () {
      this.$router.push({ name: 'ImpuestoOrganismoABM', 
                          params: { id: 0 }})
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
</style>
